var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebPagesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0453 11.3751C18.8773 10.6151 18.5979 9.9181 18.2073 9.2841C17.8166 8.6501 17.1549 7.9091 16.2223 7.0611V10.0681H15.2223V5.2981H19.9923V6.2981H16.9013C17.9639 7.2401 18.7149 8.1101 19.1543 8.9081C19.5929 9.70743 19.8919 10.5301 20.0513 11.3761L19.0453 11.3751ZM14.8373 17.8751H20.6453V14.7611H14.8373V17.8751ZM13.8373 18.8751V13.7611H21.6453V18.8761L13.8373 18.8751ZM5.29926 19.9911V18.9911H8.38926C7.19326 17.9504 6.3536 16.9261 5.87026 15.9181C5.38693 14.9101 5.14526 13.8448 5.14526 12.7221C5.14526 11.0861 5.6126 9.61643 6.54726 8.3131C7.48193 7.00976 8.68126 6.1011 10.1453 5.5871V6.6491C8.9526 7.14243 7.98793 7.94343 7.25126 9.0521C6.5146 10.1608 6.14593 11.3841 6.14526 12.7221C6.14526 13.7368 6.3596 14.6714 6.78826 15.5261C7.2176 16.3808 7.9776 17.2884 9.06826 18.2491V15.2221H10.0683V19.9921L5.29926 19.9911ZM12.8373 21.6451V20.6451H22.6453V21.6451H12.8373Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebPagesIcon);
export default __webpack_public_path__ + "static/media/WebPagesIcon.36475b12542a7f6719ed50ad35ff630f.svg";
export { ForwardRef as ReactComponent };